import PropTypes from 'prop-types'
import React, { Component } from 'react'
import CSSModules from 'react-css-modules'
import classNames from 'classnames/bind'

import styles from './base_input.scss'

class BaseInput extends Component {

	constructor() {
		super()
		this.state = {
			isFocused: false,
		}
		this.onKeyUp = this._onKeyUp.bind(this)
		this.inputRef = React.createRef()
	}

	componentDidMount() {
		if (this.props.autoSelect) {
			this.inputRef.select()
		}
	}

	_onKeyUp(ev) {
		if (ev.keyCode === 13 && this.props.onEnterKey) {
			this.props.onEnterKey()
		}
	}

	render() {
		const cx = classNames.bind(styles)
		const classValue = cx({
			block: true,
			uppercase: this.props.uppercase,
			'no-padding': this.props.noPadding,
			'line-height-40': this.props.lineHeight40,
			disabled: this.props.disabled,
		})

		return (
			<div styleName='wrapper'>
				<div styleName='content'>
					<input
						ref={inputText => this.inputRef = inputText}
						maxLength={this.props.maxLength}
						placeholder={this.props.placeholder}
						type={this.props.type}
						name={this.props.name}
						value={this.props.value}
						onBlur={this.props.onBlur}
						onDragStart={this.props.onDragStart}
						onDrop={this.props.onDrop}
						onChange={this.props.onChange}
						onInput={this.props.onInput}
						onFocus={this.props.onFocus}
						onClick={this.props.onClick}
						disabled={this.props.disabled}
						readOnly={this.props.readOnly}
						tabIndex={this.props.tabIndex}
						autoFocus={this.props.autoFocus}
						onKeyUp={this.onKeyUp}
						className={classValue}
						autoComplete={this.props.autoComplete}
					/>
				</div>
			</div>
		)
	}
}

BaseInput.defaultProps = {
	autoComplete: 'on',
	uppercase: false,
	autoFocus: false,
	noPadding: false,
	lineHeight40: false,
	autoSelect: false,
}

BaseInput.propTypes = {
	autoSelect: PropTypes.bool,
	maxLength: PropTypes.string,
	placeholder: PropTypes.string,
	type: PropTypes.string,
	name: PropTypes.string,
	onBlur: PropTypes.func,
	onChange: PropTypes.func,
	onDragStart: PropTypes.func,
	onDrop: PropTypes.func,
	onFocus: PropTypes.func,
	onEnterKey: PropTypes.func,
	onClick: PropTypes.func,
	value: PropTypes.oneOfType([
		PropTypes.string,
		PropTypes.number,
	]),
	autoComplete: PropTypes.string,
}

export default CSSModules(BaseInput, styles, {allowMultiple: true})
